

























































































































































































































import {
  TimeOffUnitEnum,
  ITimeOffTypeData,
  ITimeOffUnitData,
  TimeOffPolicy,
  TimeOffPolicyFieldError,
  ITimeOffPolicyData,
  TimeOffDurationType
} from '@/models';
import { AxiosError } from 'axios';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep } from '@/utils/helpers';
import { mapActions, mapGetters } from 'vuex';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import moment from 'moment';

import DatePicker from '../common/DatePicker.vue';
import TimeOffTypePicker from './TimeOffTypePicker.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'TimeOffDetailForm',

    components: {
      ErrorAlert,
      DatePicker,
      TimeOffTypePicker,
      ALDialog
    },

    data() {
      return {
        TimeOffDurationType,
        dialog: false,
        formValid: false,
        isEdit: false,
        loading: false,

        timeOffPolicy: {} as ITimeOffPolicyData,

        fieldError: new TimeOffPolicyFieldError(),

        errorMessage: '',
        errorMessageDetail: '',

        requiredRules: [(v: any) => !!v || 'This field is required'],

        timeOffUnitOptionList: [
          {
            value: TimeOffUnitEnum.Days,
            display_unit: TimeOffUnitEnum[TimeOffUnitEnum.Days]
          },
          {
            value: TimeOffUnitEnum.Hours,
            display_unit: TimeOffUnitEnum[TimeOffUnitEnum.Hours]
          }
        ] as ITimeOffUnitData[],

        timeOffDurationTypeList: [
          {
            value: TimeOffDurationType.Static,
            display_name: TimeOffDurationType[TimeOffDurationType.Static]
          },
          {
            value: TimeOffDurationType.Dynamic,
            display_name: TimeOffDurationType[TimeOffDurationType.Dynamic]
          }
        ]
      };
    },

    computed: {
      ...mapGetters({
        getTimeOffPolicyById: 'timeOff/getTimeOffPolicyById'
      })
    },

    watch: {
      'timeOffPolicy.is_carryover_supported': {
        handler(value) {
          this.timeOffPolicy.entitlement_amount_validity = value
            ? this.timeOffPolicy.entitlement_amount_validity
            : 0;
        }
      }
    },

    methods: {
      moment,
      ...mapActions({
        createTimeOffPolicy: 'timeOff/createTimeOffPolicy',
        updateTimeOffPolicy: 'timeOff/updateTimeOffPolicy'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async open(timeOffPolicy?: ITimeOffTypeData) {
        this.timeOffPolicy = {
          effective_date: moment().format('YYYY-MM-DD'),
          expiry_date: moment()
            .add(1, 'year')
            .format('YYYY-MM-DD'), //one year from today
          timeoff_unit: TimeOffUnitEnum.Days,
          yearly_entitlement: 0,
          timeoff_duration_type: TimeOffDurationType.Static,
          timeoff_display_option: TimeOffUnitEnum.Days
        } as ITimeOffPolicyData;

        if (timeOffPolicy) {
          this.timeOffPolicy = new TimeOffPolicy(timeOffPolicy);
        }

        this.isEdit = !!timeOffPolicy;

        this.clearAllErrors();

        this.dialog = true;

        this.resetFormValidation();
      },

      setTimeOffDurationTypePolicyData(type: TimeOffDurationType) {
        this.clearAllErrors();

        if (type == TimeOffDurationType.Static) {
          this.timeOffPolicy = new TimeOffPolicy({
            ...this.timeOffPolicy,
            effective_date: moment().format('YYYY-MM-DD'),
            expiry_date: moment()
              .add(1, 'year')
              .format('YYYY-MM-DD'), //one year from today
            timeoff_unit: TimeOffUnitEnum.Days,
            timeoff_duration_type: type,
            timeoff_display_option: TimeOffUnitEnum.Days,
            entitlement_amount_validity: 0
          });
        } else {
          this.timeOffPolicy = new TimeOffPolicy({
            ...this.timeOffPolicy,
            effective_date: null,
            expiry_date: null,
            timeoff_unit: TimeOffUnitEnum.Hours,
            timeoff_duration_type: type,
            timeoff_display_option: TimeOffUnitEnum.Hours,
            entitlement_amount_validity: 0,
            is_carryover_supported: false
          });
        }
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.clearAllErrors();
        this.dialog = false;
      },

      async saveTimeOff(): Promise<void> {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;

          try {
            if (this.isEdit) {
              const timeOffDelta = diffDeep(
                this.timeOffPolicy,
                this.getTimeOffPolicyById(this.timeOffPolicy!.id),
                true
              );

              await this.updateTimeOffPolicy(timeOffDelta);
            } else {
              await this.createTimeOffPolicy(this.timeOffPolicy);
            }

            this.loading = false;
            this.close();
          } catch (err) {
            this.loading = false;
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                TimeOffPolicyFieldError.isTimeOffPolicyFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new TimeOffPolicyFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          }
        }
      }
    }
  });
